const VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;

export const isValidVinNumber = (vin: string): boolean => {
    if (!vin) {
        return false;
    }
    const normalizedVin = vin.trim().toUpperCase();
    return VIN_REGEX.test(normalizedVin);
};
